import { createReducer } from "@reduxjs/toolkit";
import { loginAdmin, resetAccessTokenAdminAction, setAccessTokenAdminAction, userInfo } from "./actions";
import { AuthenticationReducerType } from "./types";

const initialState: AuthenticationReducerType = {
  accessToken: undefined,
  userInfo: undefined

};

const authenticationReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(loginAdmin.fulfilled, (state, action) => {
      if (action.payload) {
        state.accessToken = action.payload.accessToken || undefined;
      }
    })
    .addCase(setAccessTokenAdminAction, (state, action) => {
      state.accessToken = action.payload;
    })

    .addCase(resetAccessTokenAdminAction, (state) => {
      state.accessToken = initialState.accessToken;
    })
    .addCase(userInfo.fulfilled, (state, action) => {
      state.userInfo = action.payload;
    })

});

export default authenticationReducer;
